import React from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var cnSkeleton = cnBem('skeleton', styles);
export var Skeleton = function Skeleton(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cnSkeleton(null, [className]),
    "data-t-id": "common-Skeleton"
  });
};